import { Code, ConnectError } from '@connectrpc/connect'
import {
  WorkflowTemplateErrorReason,
  WorkflowTemplateErrorReasonSchema,
} from '@ebalance/proto/bffuser/v1/workflow_template_model_pb'

import {
  type AppErrorInfoReasonEntry,
  readAppErrorInfo,
} from '~/libs/appErrorInfo'

/**
 * `WorkflowTemplateErrorReason` (backend `workflowtemplate` domain) → i18n key。
 * 雛形の削除確認モーダル内に出す operation-scoped のエラー。
 */
const DELETE_REASON_KEYS: Record<
  WorkflowTemplateErrorReason,
  AppErrorInfoReasonEntry | undefined
> = {
  [WorkflowTemplateErrorReason.UNSPECIFIED]: undefined,
  [WorkflowTemplateErrorReason.IN_USE_BY_AUTO_CREATION_RULE]: {
    key: 'page:adminWorkflowTemplates.serverError.reason.inUseByAutoCreationRule',
  },
}

/**
 * 雛形の削除の失敗をモーダル内の文言の i18n key にする。 reason があればその文言
 * (AC-WFT-061)、 無ければ楽観ロック衝突 (Aborted) は再読み込みを促す文言、
 * それ以外は削除失敗の文言 (AC-WFT-017c)。
 */
export function resolveWorkflowTemplateDeleteErrorKey(err: unknown): string {
  if (err instanceof ConnectError) {
    const info = readAppErrorInfo(err, WorkflowTemplateErrorReasonSchema)
    const entry =
      info === undefined ? undefined : DELETE_REASON_KEYS[info.reason]
    if (entry !== undefined) return entry.key
    if (err.code === Code.Aborted) {
      return 'page:adminWorkflowTemplates.serverError.aborted'
    }
  }
  return 'page:adminWorkflowTemplates.serverError.deleteFailed'
}
